// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/main.scss
// module id = qn6L
// module chunks = 1